export type DemModuleDef = {
  slug: string;
  label: string;
  icon: string;
  title: string;
  description: string;
  desktopModule?: string;
  /** Shown after the divider (admin dock items). */
  admin?: boolean;
  /** Hidden from bottom nav for now (route may still exist). */
  navHidden?: boolean;
};

/** Mirrors the desktop Data Entry Management bottom navigation order. */
export const DEM_MODULES: DemModuleDef[] = [
  {
    slug: 'analytics',
    label: 'Dashboard',
    icon: '📊',
    title: 'Dashboard',
    description: 'Order volume, processing time and user efficiency.',
    desktopModule: 'views.ReportsFrame',
  },
  {
    slug: 'deliveries',
    label: 'Deliveries',
    icon: '🛵',
    title: 'Deliveries',
    description: 'Lalamove orders and internal deliveries with official reference quotes.',
  },
  {
    slug: 'orders',
    label: 'Orders',
    icon: '📑',
    title: 'Orders',
    description: 'Combined order list.',
  },
  {
    slug: 'blanket-orders',
    label: 'Blanket',
    icon: '📋',
    title: 'Blanket Orders',
    description: 'Customer blanket POs with partial delivery and outstanding qty.',
  },
  {
    slug: 'customer-feedback',
    label: 'CFF',
    icon: '🗒️',
    title: 'Customer Feedback Form (CFF)',
    description: 'Returns, exchanges and replenishment feedback from warehouse.',
  },
  {
    slug: 'pricing-update',
    label: 'Price update',
    icon: '💹',
    title: 'Price update',
    description: 'Price update request (PUF) — requestor / authorised / approver.',
  },
  {
    slug: 'sku-map',
    label: 'SKU Map',
    icon: '▤',
    title: 'SKU Map',
    description: 'AI customer and item mapping rules for PDF extraction.',
    desktopModule: 'views.SKUMappingFrame',
  },
  {
    slug: 'items',
    label: 'Items',
    icon: '📦',
    title: 'Items',
    description: 'Product catalog, images and pricing.',
    desktopModule: 'views.ItemsManagerFrame',
  },
  {
    slug: 'customers',
    label: 'Customers',
    icon: '👥',
    title: 'Customers',
    description: 'Customer master data, delivery schedules and portal tokens.',
    desktopModule: 'views.CustomersFrame',
  },
  {
    slug: 'standard-sales-lines',
    label: 'Std Lines',
    icon: '☰',
    title: 'Standard Sales Lines',
    description: 'Frequent order lines per customer (template code).',
  },
  {
    slug: 'dispatch',
    label: 'Dispatch',
    icon: '🚚',
    title: 'Dispatch',
    description: 'Plan delivery trips and assign drivers.',
    desktopModule: 'dispatch_module.py',
    navHidden: true,
  },
  {
    slug: 'cloudtalk',
    label: 'CloudTalk',
    icon: '☁️',
    title: 'CloudTalk',
    description: 'Missed calls and telephony activity.',
    desktopModule: 'views.CloudTalkCenterFrame',
  },
  {
    slug: 'master-data',
    label: 'Master Data',
    icon: '🗄️',
    title: 'Master Data',
    description: 'Sync customers, items and prices from the server.',
    desktopModule: 'views.MasterUpdateWindow',
    admin: true,
    // Shown under Settings → DEM configuration, not the bottom dock.
    navHidden: true,
  },
];

export const DEM_DEFAULT_SLUG = 'analytics';

export const DEM_MAIN_MODULES = DEM_MODULES.filter((m) => !m.admin && !m.navHidden);
export const DEM_ADMIN_MODULES = DEM_MODULES.filter((m) => m.admin && !m.navHidden);
